<script setup lang="ts">
import SelectWithoutIcon from '@/components/BaseComponents/SelectWithoutIcon.vue';
import CreationFilter from '@/components/Menus/Filters/CreationFilter.vue';
import { type MessageSchema } from '@/i18n';
import { useDishesStore } from '@/stores/dishesStore';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n<{ message: MessageSchema }>({ useScope: 'global' });

const dishesStore = ref(useDishesStore());

const dietTypeList = ref([
  'vegetarian',
  'vegan',
  // 'withoutLactose',
  // 'withoutGluten',
  'pescetarian',
  'fitness',
  'keto',
]);
</script>

<template>
  <CreationFilter>
    <template #title>{{ t('creationFilters.dietType') }}</template>
    <template #content>
      <div class="flex w-full flex-wrap justify-center gap-2">
        <SelectWithoutIcon
          v-for="dietType in dietTypeList"
          :key="dietType"
          :selected="dishesStore.generationParams.dish_diet.includes(dietType)"
          @handle-select="
            (selected) =>
              selected
                ? dishesStore.generationParams.dish_diet.push(dietType)
                : (dishesStore.generationParams.dish_diet = dishesStore.generationParams.dish_diet.filter((i) => i !== dietType))
          "
        >
          <template #label>{{ t(`creationFilters.dietTypeList.${dietType}`) }}</template>
        </SelectWithoutIcon>
      </div>
    </template>
  </CreationFilter>
</template>
